'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sheets = exports.onCheckMobile = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = require('@material-ui/core');

var _Drawer = require('@material-ui/core/Drawer');

var _Drawer2 = _interopRequireDefault(_Drawer);

var _sheets = require('../../schema/component/sheets.json');

var _Button = require('../Button');

var _Typography = require('../Typography');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


// Lazy Load
var Avatar = (0, _react.lazy)(function () {
  return import('@material-ui/core/Avatar');
});
var CloseIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/Close');
});
var ImageIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/Image');
});

var useStyles = (0, _core.makeStyles)({
  drawer: {
    '& .MuiDrawer-paper': {
      background: 'var(--onprimary-high-emphasis)',
      borderRadius: function borderRadius(_ref) {
        var papperBorderRadius = _ref.papperBorderRadius;
        return papperBorderRadius;
      },
      flexFlow: 'wrap',
      minHeight: function minHeight(_ref2) {
        var papperHeight = _ref2.papperHeight;
        return papperHeight;
      },
      margin: '0 auto',
      overflowY: 'hidden',
      width: function width(_ref3) {
        var papperWidth = _ref3.papperWidth;
        return papperWidth;
      }
    }
  },
  content: {
    display: 'block',
    height: '100%',
    padding: function padding(_ref4) {
      var contentPadding = _ref4.contentPadding;
      return contentPadding;
    },
    width: '100%'
  },
  image: {
    borderRadius: '0px',
    height: '208px',
    margin: '-16px 0px 16px -24px',
    width: 'calc(100% + (24px * 2))',
    '& svg': {
      fontSize: '48px'
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '4px'
  },
  title: {},
  icon: {
    color: 'var(--onsurface-inactive)',
    cursor: 'pointer',
    marginLeft: '16px'
  }
});

var onCheckMobile = exports.onCheckMobile = function onCheckMobile(attr, width) {
  if (attr) {
    if (attr.isMobile && width > 1024) {
      return '360px';
    }
    return attr.papperWidth;
  }
  return null;
};

var Sheets = function Sheets(_ref5) {
  var actionEvent = _ref5.actionEvent,
      actionProps = _ref5.actionProps,
      actionText = _ref5.actionText,
      actionVariant = _ref5.actionVariant,
      children = _ref5.children,
      closeProps = _ref5.closeProps,
      image = _ref5.image,
      imageProps = _ref5.imageProps,
      isCloseOverlay = _ref5.isCloseOverlay,
      justifyContent = _ref5.justifyContent,
      message = _ref5.message,
      messageProps = _ref5.messageProps,
      open = _ref5.open,
      onClose = _ref5.onClose,
      title = _ref5.title,
      titleProps = _ref5.titleProps,
      variant = _ref5.variant,
      props = _objectWithoutProperties(_ref5, ['actionEvent', 'actionProps', 'actionText', 'actionVariant', 'children', 'closeProps', 'image', 'imageProps', 'isCloseOverlay', 'justifyContent', 'message', 'messageProps', 'open', 'onClose', 'title', 'titleProps', 'variant']);

  var attr = _sheets.properties[variant] && _sheets.properties[variant].properties;
  var classes = useStyles({
    isMobile: attr && attr.isMobile,
    papperBorderRadius: attr && attr.papperBorderRadius,
    papperHeight: attr && attr.papperHeight,
    contentPadding: attr && attr.contentPadding,
    papperWidth: attr && onCheckMobile(attr, window.innerWidth),
    width: window.innerWidth
  });

  return _react2.default.createElement(
    _Drawer2.default,
    _extends({}, props, {
      className: classes.drawer,
      anchor: 'bottom',
      open: open,
      onClose: isCloseOverlay ? onClose : function () {}
    }),
    children,
    _react2.default.createElement(
      'div',
      { className: classes.content },
      !children && attr && attr.imageShow && _react2.default.createElement(
        _react.Suspense,
        { fallback: _react2.default.createElement('div', null) },
        _react2.default.createElement(
          Avatar,
          _extends({
            className: classes.image,
            src: image
          }, imageProps, {
            alt: 'Gambar Ilustrasi',
            title: 'Gambar Ilustrasi'
          }),
          _react2.default.createElement(ImageIcon, null)
        )
      ),
      !children && attr && attr.titleShow && _react2.default.createElement(
        'div',
        { className: classes.header },
        _react2.default.createElement(_Typography.Typography, _extends({
          className: classes.title,
          variant: attr && attr.titleVariant,
          'data-text-align': justifyContent
        }, titleProps, {
          dangerouslySetInnerHTML: { __html: title }
        })),
        attr.isClose && _react2.default.createElement(
          _react.Suspense,
          { fallback: _react2.default.createElement('div', null) },
          _react2.default.createElement(CloseIcon, _extends({
            className: classes.icon,
            onClick: onClose
          }, closeProps))
        )
      ),
      !children && attr && attr.messageShow && _react2.default.createElement(_Typography.Typography, _extends({
        className: classes.message,
        variant: attr && attr.messageVariant,
        'data-text-align': justifyContent
      }, messageProps, {
        dangerouslySetInnerHTML: { __html: message }
      })),
      !children && attr && attr.buttonShow && _react2.default.createElement(
        _Button.Button,
        _extends({
          fullWidth: true,
          type: actionVariant || attr.buttonVariant,
          'data-margin-top': '40px',
          onClick: actionEvent || onClose
        }, actionProps),
        actionText
      )
    )
  );
};

exports.Sheets = Sheets;
Sheets.defaultProps = {
  actionEvent: null,
  actionProps: null,
  actionText: 'Mengerti',
  actionVariant: null,
  children: null,
  closeProps: null,
  image: null,
  imageProps: null,
  isCloseOverlay: false,
  justifyContent: 'left',
  message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do minim veniam nostrud exercitation eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  messageProps: null,
  onClose: function onClose() {},
  open: false,
  title: 'Lorem Ipsum Dolor',
  titleProps: null,
  variant: null
};

Sheets.propTypes = {
  actionEvent: _propTypes2.default.func,
  actionProps: _propTypes2.default.shape({}),
  actionText: _propTypes2.default.string,
  actionVariant: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  closeProps: _propTypes2.default.shape({}),
  image: _propTypes2.default.string,
  imageProps: _propTypes2.default.shape({}),
  isCloseOverlay: _propTypes2.default.bool,
  justifyContent: _propTypes2.default.string,
  message: _propTypes2.default.string,
  messageProps: _propTypes2.default.shape({}),
  onClose: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  titleProps: _propTypes2.default.shape({}),
  variant: _propTypes2.default.string
};

exports.default = Sheets;